import React from 'react';
import {
  Box,
  Typography,
  Container,
  Paper,
  Card,
  CardContent,
  Button,
  Stack,
  Chip,
} from '@mui/material';
import {
  ArrowBack as ArrowBackIcon,
  School as SchoolIcon,
  TrendingUp as TrendingUpIcon,
  EmojiEvents as TrophyIcon,
  Psychology as BrainIcon,
  CheckCircle as CheckIcon,
  Apple as AppleIcon,
  Android as AndroidIcon,
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const About = () => {
  const navigate = useNavigate();

  const features = [
    {
      icon: <BrainIcon sx={{ fontSize: 40, color: '#3B82F6' }} />,
      title: 'Günlük Sorular',
      description: 'Her gün yeni LGS soruları ile sürekli gelişim sağlayın. Tüm derslerden güncel sorular.',
      stats: 'Her Gün Yeni Günlük Soru'
    },
    {
      icon: <TrendingUpIcon sx={{ fontSize: 40, color: '#10B981' }} />,
      title: 'Gerçek Zamanlı Sıralama',
      description: 'Diğer öğrencilerle yarışın ve anlık sıralamanızı takip edin. Motivasyonunuzu yüksek tutun.',
      stats: 'Aktif Öğrenciler'
    },
    {
      icon: <CheckIcon sx={{ fontSize: 40, color: '#F59E0B' }} />,
      title: 'Anında Geri Bildirim',
      description: 'Sorularınızı çözdükten hemen sonra detaylı açıklamalı cevapları görün.',
      stats: '95% Memnuniyet'
    },
    {
      icon: <TrophyIcon sx={{ fontSize: 40, color: '#EF4444' }} />,
      title: 'Ödül Sistemi',
      description: 'Başarılarınız için değerli ders kitapları ve hediyeler kazanın.',
      stats: 'Eğlenceli Hediyeler'
    }
  ];

  const subjects = [
    { name: 'Matematik', icon: '🔢', description: 'Sayılar, cebir, geometri ve problem çözme' },
    { name: 'Fen Bilimleri', icon: '🧪', description: 'Fizik, kimya, biyoloji ve doğa bilimleri' },
    { name: 'Türkçe', icon: '📚', description: 'Dil bilgisi, okuma anlama ve yazım kuralları' },
    { name: 'Sosyal Bilgiler', icon: '🌍', description: 'Tarih, coğrafya ve vatandaşlık bilgisi' },
    { name: 'İngilizce', icon: '🌐', description: 'Kelime bilgisi, gramer ve okuma anlama' }
  ];

  {/*const stats = [
    { number: '50,000+', label: 'Kayıtlı Öğrenci' },
    { number: '1M+', label: 'Çözülen Soru' },
    { number: '95%', label: 'Başarı Oranı' },
    { number: '4.8', label: 'Uygulama Puanı' }
  ];*/}

  return (
    <Box sx={{ minHeight: '100vh', backgroundColor: '#f8fafc' }}>
      <Container maxWidth="lg" sx={{ py: 4 }}>
        <Button
          startIcon={<ArrowBackIcon />}
          onClick={() => navigate('/')}
          sx={{ mb: 3, color: '#4338CA' }}
        >
          Ana Sayfaya Dön
        </Button>

        {/* Hero Section */}
        <Box sx={{ textAlign: 'center', mb: 8 }}>
          <Typography variant="h2" sx={{ fontWeight: 700, mb: 3, color: '#1e293b' }}>
            LGSCİYİZ Hakkında
          </Typography>
          <Typography variant="h5" sx={{ color: '#64748b', maxWidth: 800, mx: 'auto', mb: 4 }}>
            LGS'ye hazırlanan öğrenciler için tasarlanmış akıllı çalışma asistanı. 
            Günlük sorular, gerçek zamanlı sıralama ve kişiselleştirilmiş öğrenme deneyimi.
          </Typography>
          
          {/* Download Buttons */}
          <Stack 
            direction={{ xs: 'column', sm: 'row' }} 
            spacing={3}
            sx={{ justifyContent: 'center', mb: 6 }}
          >
            <Button
              variant="contained"
              size="large"
              startIcon={<AppleIcon />}
              sx={{
                background: 'linear-gradient(45deg, #000000 30%, #333333 90%)',
                color: 'white',
                borderRadius: 3,
                py: 2,
                px: 4,
                fontSize: '1rem',
                fontWeight: 600,
                '&:hover': {
                  background: 'linear-gradient(45deg, #111111 30%, #444444 90%)',
                }
              }}
            >
              App Store'dan İndir
            </Button>
            <Button
              variant="contained"
              size="large"
              startIcon={<AndroidIcon />}
              sx={{
                background: 'linear-gradient(45deg, #4CAF50 30%, #8BC34A 90%)',
                color: 'white',
                borderRadius: 3,
                py: 2,
                px: 4,
                fontSize: '1rem',
                fontWeight: 600,
                '&:hover': {
                  background: 'linear-gradient(45deg, #43A047 30%, #7CB342 90%)',
                }
              }}
            >
              Google Play'den İndir
            </Button>
          </Stack>

          {/* Stats */}
          {/*<Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 3, justifyContent: 'center', mb: 8 }}>
            {stats.map((stat, index) => (
              <Box key={index} sx={{ minWidth: { xs: '45%', md: '20%' } }}>
                <Paper elevation={0} sx={{ p: 3, textAlign: 'center', borderRadius: 3 }}>
                  <Typography variant="h3" sx={{ fontWeight: 700, color: '#4338CA', mb: 1 }}>
                    {stat.number}
                  </Typography>
                  <Typography variant="body2" sx={{ color: '#64748b', fontWeight: 500 }}>
                    {stat.label}
                  </Typography>
                </Paper>
              </Box>
            ))}
          </Box>*/}
        </Box>

        {/* Mission Section */}
        <Paper elevation={0} sx={{ p: 6, mb: 8, borderRadius: 3, background: 'linear-gradient(135deg, #4338CA 0%, #6D28D9 100%)', color: 'white' }}>
          <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, alignItems: 'center', gap: 4 }}>
            <Box sx={{ flex: 1 }}>
              <Typography variant="h4" sx={{ fontWeight: 700, mb: 3 }}>
                Misyonumuz
              </Typography>
              <Typography variant="body1" sx={{ lineHeight: 1.8, mb: 4, opacity: 0.95 }}>
                LGS'ye hazırlanan her öğrencinin başarılı olması için eşit fırsatlar sunmak. 
                Teknoloji ile eğitimi birleştirerek, öğrencilerin potansiyellerini keşfetmelerine 
                yardımcı olmak ve onları hedeflerine ulaştırmak.
              </Typography>
              <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
                <Chip label="Eşit Fırsat" sx={{ backgroundColor: 'rgba(255,255,255,0.2)', color: 'white' }} />
                <Chip label="Teknoloji" sx={{ backgroundColor: 'rgba(255,255,255,0.2)', color: 'white' }} />
                <Chip label="Başarı" sx={{ backgroundColor: 'rgba(255,255,255,0.2)', color: 'white' }} />
              </Box>
            </Box>
            <Box sx={{ flex: 1, textAlign: 'center' }}>
              <SchoolIcon sx={{ fontSize: 120, opacity: 0.3 }} />
            </Box>
          </Box>
        </Paper>

        {/* Features Section */}
        <Box sx={{ mb: 8 }}>
          <Typography variant="h4" sx={{ fontWeight: 700, textAlign: 'center', mb: 6, color: '#1e293b' }}>
            Neden LGSCİYİZ?
          </Typography>
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
            {features.map((feature, index) => (
              <Box key={index} sx={{ minWidth: { xs: '100%', md: '45%' }, flex: 1 }}>
                <Card sx={{ 
                  height: '100%', 
                  borderRadius: 3, 
                  border: '1px solid #e2e8f0',
                  '&:hover': {
                    boxShadow: '0 10px 25px rgba(0,0,0,0.1)',
                    transform: 'translateY(-2px)',
                    transition: 'all 0.3s ease'
                  }
                }}>
                  <CardContent sx={{ p: 4 }}>
                    <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 3 }}>
                      <Box sx={{ 
                        p: 2, 
                        borderRadius: 3, 
                        backgroundColor: `${feature.icon.props.sx.color}15`,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                      }}>
                        {feature.icon}
                      </Box>
                      <Box sx={{ flex: 1 }}>
                        <Typography variant="h6" sx={{ fontWeight: 600, mb: 2 }}>
                          {feature.title}
                        </Typography>
                        <Typography variant="body2" sx={{ color: '#64748b', mb: 3, lineHeight: 1.6 }}>
                          {feature.description}
                        </Typography>
                        <Chip 
                          label={feature.stats} 
                          size="small" 
                          sx={{ 
                            backgroundColor: `${feature.icon.props.sx.color}15`,
                            color: feature.icon.props.sx.color,
                            fontWeight: 600
                          }} 
                        />
                      </Box>
                    </Box>
                  </CardContent>
                </Card>
              </Box>
            ))}
          </Box>
        </Box>

        {/* Subjects Section */}
        <Paper elevation={0} sx={{ p: 6, mb: 8, borderRadius: 3 }}>
          <Typography variant="h4" sx={{ fontWeight: 700, textAlign: 'center', mb: 6, color: '#1e293b' }}>
            Kapsanan Dersler
          </Typography>
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 3, justifyContent: 'center' }}>
            {subjects.map((subject, index) => (
              <Box key={index} sx={{ minWidth: { xs: '100%', sm: '45%', md: '30%' }, flex: 1, maxWidth: '300px' }}>
                <Card sx={{ 
                  textAlign: 'center', 
                  p: 3, 
                  borderRadius: 3,
                  border: '1px solid #e2e8f0',
                  height: '100%',
                  '&:hover': {
                    boxShadow: '0 5px 15px rgba(0,0,0,0.08)',
                    transform: 'translateY(-2px)',
                    transition: 'all 0.3s ease'
                  }
                }}>
                  <Typography variant="h2" sx={{ mb: 2 }}>
                    {subject.icon}
                  </Typography>
                  <Typography variant="h6" sx={{ fontWeight: 600, mb: 2 }}>
                    {subject.name}
                  </Typography>
                  <Typography variant="body2" sx={{ color: '#64748b' }}>
                    {subject.description}
                  </Typography>
                </Card>
              </Box>
            ))}
          </Box>
        </Paper>

        {/* Contact CTA */}
        <Paper elevation={0} sx={{ 
          p: 6, 
          textAlign: 'center', 
          borderRadius: 3,
          background: 'linear-gradient(135deg, #10B981 0%, #059669 100%)',
          color: 'white'
        }}>
          <Typography variant="h4" sx={{ fontWeight: 700, mb: 3 }}>
            Sorularınız mı var?
          </Typography>
          <Typography variant="body1" sx={{ mb: 4, opacity: 0.95, maxWidth: 600, mx: 'auto' }}>
            LGSCİYİZ hakkında daha fazla bilgi almak veya destek için bizimle iletişime geçin.
          </Typography>
          <Button
            variant="contained"
            size="large"
            onClick={() => navigate('/support')}
            sx={{
              backgroundColor: 'rgba(255,255,255,0.2)',
              color: 'white',
              borderRadius: 3,
              py: 2,
              px: 4,
              fontSize: '1rem',
              fontWeight: 600,
              '&:hover': {
                backgroundColor: 'rgba(255,255,255,0.3)',
              }
            }}
          >
            Destek Merkezi
          </Button>
        </Paper>
      </Container>
    </Box>
  );
};

export default About;